import React from "react";
import { HelpCircle, Phone, Mail, MessageCircle, ExternalLink } from "lucide-react";

const AMC_WHATSAPP = "5511956649968"; // ajuste conforme número real
const AMC_EMAIL = "amcescolas@gmail.com";
const AMC_PHONE = "1156649968";

function ContactRow({ bg, icon: Icon, iconColor, title, text, action, href, testid }) {
  return (
    <a
      href={href}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel="noreferrer"
      data-testid={testid}
      className="flex items-start gap-3 p-3 -mx-3 rounded-xl hover:bg-slate-50 transition-colors group"
    >
      <div className={`w-11 h-11 rounded-xl ${bg} flex items-center justify-center shrink-0`}>
        <Icon className={`w-5 h-5 ${iconColor}`} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900 text-sm">{title}</p>
        <p className="text-sm text-slate-600 break-words">{text}</p>
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#7c3aed] mt-1 group-hover:underline">
          {action} <ExternalLink className="w-3 h-3" />
        </span>
      </div>
    </a>
  );
}

export default function SchoolAjuda() {
  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-black text-[#1e3a8a]">Ajuda e suporte</h1>
        <p className="text-sm text-slate-500">Entre em contato com a AMC Escolas</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 card-shadow p-5 space-y-1">
        <ContactRow
          testid="help-whatsapp"
          href={`https://wa.me/${AMC_WHATSAPP}`}
          bg="bg-emerald-100"
          icon={MessageCircle}
          iconColor="text-emerald-600"
          title="WhatsApp"
          text="Fale com nossa equipe pelo WhatsApp"
          action="Abrir conversa"
        />
        <ContactRow
          testid="help-phone"
          href={`tel:+55${AMC_PHONE}`}
          bg="bg-sky-100"
          icon={Phone}
          iconColor="text-sky-600"
          title="Telefone"
          text={`(11) ${AMC_PHONE.slice(2, 6)}-${AMC_PHONE.slice(6)}`}
          action="Ligar agora"
        />
        <ContactRow
          testid="help-email"
          href={`mailto:${AMC_EMAIL}`}
          bg="bg-blue-100"
          icon={Mail}
          iconColor="text-blue-600"
          title="E-mail"
          text={AMC_EMAIL}
          action="Enviar e-mail"
        />
        <div className="flex items-start gap-3 p-3 -mx-3 rounded-xl">
          <div className="w-11 h-11 rounded-xl bg-[#7c3aed]/10 flex items-center justify-center shrink-0">
            <HelpCircle className="w-5 h-5 text-[#7c3aed]" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-slate-900 text-sm">Dúvidas sobre acesso</p>
            <p className="text-sm text-slate-600">
              Para redefinir seu acesso ou alterar o diretor cadastrado, entre em contato pelos canais acima.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
